import { ProjectMilestoneStatus } from "@/enums";
import { flattenProjectScheduleMilestones } from "./flattenProjectScheduleMilestones";

// Return true if project has rejected milestone that is not marked as ShouldCompleteProject.
export const projectHasRejectedMilestone = (project) => {
  if (!project) return false;

  const projectMilestones = flattenProjectScheduleMilestones(project);
  const projectCompleteMilestone =
    projectMilestones?.find(
      ({ shouldCompleteProject }) => shouldCompleteProject === true
    ) ?? false;

  const milestonesInInvalidStatus = projectMilestones.filter(
    ({ id, status }) =>
      status === ProjectMilestoneStatus.Rejected &&
      id !== projectCompleteMilestone?.id
  );

  return !!milestonesInInvalidStatus?.length;
};
